import { render } from "./AgentHistoryView.vue?vue&type=template&id=488561fc"
import script from "./AgentHistoryView.vue?vue&type=script&lang=js"
export * from "./AgentHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__